<template>
  <div>
    <vxe-grid
      size="mini"
      border
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:containerAmount="{ row }">
        <span>{{ row.containerPriceAmount }}{{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:containerSalePrice="{ row }">
        <span>
          {{ row.containerSalePriceAmout }}{{ row.v_salesCurrencyUnit }}
        </span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
}
</script>
